import React, { useEffect, useRef, useState } from 'react';
import './index.scss';
export default function StepProgress(props) {
  const { currentStep, totalSteps } = props;
  const totalWidthRef = useRef(null);
  const [stepWidth, setStepWidth] = useState(0);
  useEffect(() => {
    if (!totalWidthRef.current) return;
    const totalWidth = totalWidthRef.current.offsetWidth;
    setStepWidth((totalWidth / totalSteps) * currentStep);
  }, [currentStep, totalSteps]);

  return (
    <div className="step-progress_container">
      <div className="step-progress" ref={totalWidthRef}>
        <div
          className="step-progress__bar"
          style={{
            width: stepWidth + 'px',
          }}
        />
      </div>
      <span>
        {currentStep}/{totalSteps}
      </span>
    </div>
  );
}
